export const ApiActivityStatuses = {
    new: 0,
    scheduled: 1,
    completed: 2,
    uncompleted: 3
};
